import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SkillDal } from '../dal/skill.dal';
import { SkillData } from '../interfaces/profile.interfaces';
import { AnesthRating, RoleLevel, Skill } from '../models/skill.model';

@Injectable({
  providedIn: 'root',
})
export class SkillService {
  constructor(private skillDal: SkillDal) {}

  getSkillsOfNurse(nurseId: string): Observable<Skill[]> {
    return this.skillDal.getSkillsOfNurse(nurseId);
  }

  getManySkillOfNurses(nursesIds: string[], specialesIds: string[]): Observable<Skill[]> {
    return this.skillDal.getManySkillOfNurses(nursesIds, specialesIds);
  }

  getNurseRating(profilId: string, hospitalId: string, date: string, vacationsId: string[]): Observable<RoleLevel[]> {
    return this.skillDal.getNurseRating(profilId, hospitalId, date, vacationsId);
  }

  getAllRatings(date: string): Observable<any[]> {
    return this.skillDal.getAllRatings(date);
  }

  getAnesthRating(
    profilId: string,
    hospitalId: string,
    type: string,
    date: string,
    vacationsId: string[],
    specialty?: string
  ): Observable<AnesthRating> {
    return this.skillDal.getAnesthRating(profilId, hospitalId, type, date, vacationsId, specialty);
  }

  getAllAnesthRatings(date: string): Observable<AnesthRating[]> {
    return this.skillDal.getAllAnesthRatings(date);
  }

  getSkillHistoryAndSkill(profileId: string, specialty: string, role: string) {
    return this.skillDal.getSkillHistoryAndSkill(profileId, specialty, role);
  }

  getSkillsOfProfileForHospitalFromOtherHospitals(profileId: string, hospitalId: string): Observable<any[]> {
    return this.skillDal.getSkillsOfProfileForHospitalFromOtherHospitals(profileId, hospitalId);
  }

  updateSkills(skillsList: any) {
    return this.skillDal.updateSkills(skillsList);
  }

  initNursesSkills(skills: SkillData[]) {
    return this.skillDal.initNursesSkills(skills);
  }

  getNursesSkills(page: number = 1, limit: number = 15, data: any, search: string = ''): Observable<any> {
    return this.skillDal.getNursesSkills(page, limit, data, search);
  }

  exportSkills(data: any): Observable<any[]> {
    return this.skillDal.exportSkills(data);
  }
}
